export default [
  {
    code: 'ab',
    name: 'Abkhaz',
    local_name: 'аҧсуа',
  },
  {
    code: 'aa',
    name: 'Afar',
    local_name: 'Afaraf',
  },
  {
    code: 'af',
    name: 'Afrikaans',
    local_name: 'Afrikaans',
  },
  {
    code: 'ak',
    name: 'Akan',
    local_name: 'Akan',
  },
  {
    code: 'sq',
    name: 'Albanian',
    local_name: 'Shqip',
  },
  {
    code: 'am',
    name: 'Amharic',
    local_name: 'አማርኛ',
  },
  {
    code: 'ar',
    name: 'Arabic',
    local_name: 'العربية',
  },
  {
    code: 'an',
    name: 'Aragonese',
    local_name: 'Aragonés',
  },
  {
    code: 'hy',
    name: 'Armenian',
    local_name: 'Հայերեն',
  },
  {
    code: 'as',
    name: 'Assamese',
    local_name: 'অসমীয়া',
  },
  {
    code: 'av',
    name: 'Avaric',
    local_name: 'Авар мацӀ',
  },
  {
    code: 'ae',
    name: 'Avestan',
    local_name: 'Avesta',
  },
  {
    code: 'ay',
    name: 'Aymara',
    local_name: 'Aymar aru',
  },
  {
    code: 'az',
    name: 'Azerbaijani',
    local_name: 'Azərbaycan dili',
  },
  {
    code: 'bm',
    name: 'Bambara',
    local_name: 'Bamanankan',
  },
  {
    code: 'ba',
    name: 'Bashkir',
    local_name: 'Башҡорт теле',
  },
  {
    code: 'eu',
    name: 'Basque',
    local_name: 'Euskara',
  },
  {
    code: 'be',
    name: 'Belarusian',
    local_name: 'Беларуская',
  },
  {
    code: 'bn',
    name: 'Bengali',
    local_name: 'বাংলা',
  },
  {
    code: 'bh',
    name: 'Bihari',
    local_name: 'भोजपुरी',
  },
  {
    code: 'bi',
    name: 'Bislama',
    local_name: 'Bislama',
  },
  {
    code: 'bs',
    name: 'Bosnian',
    local_name: 'Bosanski jezik',
  },
  {
    code: 'br',
    name: 'Breton',
    local_name: 'Brezhoneg',
  },
  {
    code: 'bg',
    name: 'Bulgarian',
    local_name: 'Български език',
  },
  {
    code: 'my',
    name: 'Burmese',
    local_name: 'ဗမာစာ',
  },
  {
    code: 'ca',
    name: 'Catalan',
    local_name: 'Català',
  },
  {
    code: 'ch',
    name: 'Chamorro',
    local_name: 'Chamoru',
  },
  {
    code: 'ce',
    name: 'Chechen',
    local_name: 'Нохчийн мотт',
  },
  {
    code: 'ny',
    name: 'Chichewa',
    local_name: 'ChiCheŵa',
  },
  {
    code: 'zh',
    name: 'Chinese',
    local_name: '中文 (Zhōngwén), 汉语, 漢語',
  },
  {
    code: 'cv',
    name: 'Chuvash',
    local_name: 'Чӑваш чӗлхи',
  },
  {
    code: 'kw',
    name: 'Cornish',
    local_name: 'Kernewek',
  },
  {
    code: 'co',
    name: 'Corsican',
    local_name: 'Corsu',
  },
  {
    code: 'cr',
    name: 'Cree',
    local_name: 'ᓀᐦᐃᔭᐍᐏᐣ',
  },
  {
    code: 'hr',
    name: 'Croatian',
    local_name: 'Hrvatski',
  },
  {
    code: 'cs',
    name: 'Czech',
    local_name: 'Česky',
  },
  {
    code: 'da',
    name: 'Danish',
    local_name: 'Dansk',
  },
  {
    code: 'dv',
    name: 'Divehi',
    local_name: 'ދިވެހި',
  },
  {
    code: 'nl',
    name: 'Dutch',
    local_name: 'Nederlands, Vlaams',
  },
  {
    code: 'en',
    name: 'English',
    local_name: 'English',
  },
  {
    code: 'eo',
    name: 'Esperanto',
    local_name: 'Esperanto',
  },
  {
    code: 'et',
    name: 'Estonian',
    local_name: 'Eesti',
  },
  {
    code: 'ee',
    name: 'Ewe',
    local_name: 'Eʋegbe',
  },
  {
    code: 'fo',
    name: 'Faroese',
    local_name: 'Føroyskt',
  },
  {
    code: 'fj',
    name: 'Fijian',
    local_name: 'Vosa Vakaviti',
  },
  {
    code: 'fi',
    name: 'Finnish',
    local_name: 'Suomi',
  },
  {
    code: 'fr',
    name: 'French',
    local_name: 'Français',
  },
  {
    code: 'ff',
    name: 'Fula',
    local_name: 'Fulfulde',
  },
  {
    code: 'gl',
    name: 'Galician',
    local_name: 'Galego',
  },
  {
    code: 'ka',
    name: 'Georgian',
    local_name: 'ქართული',
  },
  {
    code: 'de',
    name: 'German',
    local_name: 'Deutsch',
  },
  {
    code: 'el',
    name: 'Greek, Modern',
    local_name: 'Ελληνικά',
  },
  {
    code: 'gn',
    name: 'Guaraní',
    local_name: 'Avañeẽ',
  },
  {
    code: 'gu',
    name: 'Gujarati',
    local_name: 'ગુજરાતી',
  },
  {
    code: 'ht',
    name: 'Haitian',
    local_name: 'Kreyòl ayisyen',
  },
  {
    code: 'ha',
    name: 'Hausa',
    local_name: 'هَوُسَ',
  },
  {
    code: 'he',
    name: 'Hebrew (modern)',
    local_name: 'עברית',
  },
  {
    code: 'hz',
    name: 'Herero',
    local_name: 'Otjiherero',
  },
  {
    code: 'hi',
    name: 'Hindi',
    local_name: 'हिन्दी, हिंदी',
  },
  {
    code: 'ho',
    name: 'Hiri Motu',
    local_name: 'Hiri Motu',
  },
  {
    code: 'hu',
    name: 'Hungarian',
    local_name: 'Magyar',
  },
  {
    code: 'ia',
    name: 'Interlingua',
    local_name: 'Interlingua',
  },
  {
    code: 'id',
    name: 'Indonesian',
    local_name: 'Bahasa Indonesia',
  },
  {
    code: 'ie',
    name: 'Interlingue',
    local_name: 'Interlingue',
  },
  {
    code: 'ga',
    name: 'Irish',
    local_name: 'Gaeilge',
  },
  {
    code: 'ig',
    name: 'Igbo',
    local_name: 'Asụsụ Igbo',
  },
  {
    code: 'ik',
    name: 'Inupiaq',
    local_name: 'Iñupiaq',
  },
  {
    code: 'io',
    name: 'Ido',
    local_name: 'Ido',
  },
  {
    code: 'is',
    name: 'Icelandic',
    local_name: 'Íslenska',
  },
  {
    code: 'it',
    name: 'Italian',
    local_name: 'Italiano',
  },
  {
    code: 'iu',
    name: 'Inuktitut',
    local_name: 'ᐃᓄᒃᑎᑐᑦ',
  },
  {
    code: 'ja',
    name: 'Japanese',
    local_name: '日本語 (にほんご／にっぽんご)',
  },
  {
    code: 'jv',
    name: 'Javanese',
    local_name: 'Basa Jawa',
  },
  {
    code: 'kl',
    name: 'Kalaallisut, Greenlandic',
    local_name: 'Kalaallisut',
  },
  {
    code: 'kn',
    name: 'Kannada',
    local_name: 'ಕನ್ನಡ',
  },
  {
    code: 'kr',
    name: 'Kanuri',
    local_name: 'Kanuri',
  },
  {
    code: 'ks',
    name: 'Kashmiri',
    local_name: 'कश्मीरी, كشميري‎',
  },
  {
    code: 'kk',
    name: 'Kazakh',
    local_name: 'Қазақ тілі',
  },
  {
    code: 'km',
    name: 'Khmer',
    local_name: 'ភាសាខ្មែរ',
  },
  {
    code: 'ki',
    name: 'Kikuyu, Gikuyu',
    local_name: 'Gĩkũyũ',
  },
  {
    code: 'rw',
    name: 'Kinyarwanda',
    local_name: 'Ikinyarwanda',
  },
  {
    code: 'ky',
    name: 'Kirghiz, Kyrgyz',
    local_name: 'Кыргыз тили',
  },
  {
    code: 'kv',
    name: 'Komi',
    local_name: 'Коми кыв',
  },
  {
    code: 'kg',
    name: 'Kongo',
    local_name: 'KiKongo',
  },
  {
    code: 'ko',
    name: 'Korean',
    local_name: '한국어 (韓國語), 조선말 (朝鮮語)',
  },
  {
    code: 'ku',
    name: 'Kurdish',
    local_name: 'Kurdî, كوردی‎',
  },
  {
    code: 'kj',
    name: 'Kwanyama',
    local_name: 'Kuanyama',
  },
  {
    code: 'la',
    name: 'Latin',
    local_name: 'Latine',
  },
  {
    code: 'lb',
    name: 'Luxembourgish',
    local_name: 'Lëtzebuergesch',
  },
  {
    code: 'lg',
    name: 'Luganda',
    local_name: 'Luganda',
  },
  {
    code: 'li',
    name: 'Limburgish',
    local_name: 'Limburgs',
  },
  {
    code: 'ln',
    name: 'Lingala',
    local_name: 'Lingála',
  },
  {
    code: 'lo',
    name: 'Lao',
    local_name: 'ພາສາລາວ',
  },
  {
    code: 'lt',
    name: 'Lithuanian',
    local_name: 'Lietuvių kalba',
  },
  {
    code: 'lu',
    name: 'Luba-Katanga',
    local_name: '',
  },
  {
    code: 'lv',
    name: 'Latvian',
    local_name: 'Latviešu valoda',
  },
  {
    code: 'gv',
    name: 'Manx',
    local_name: 'Gaelg',
  },
  {
    code: 'mk',
    name: 'Macedonian',
    local_name: 'Македонски јазик',
  },
  {
    code: 'mg',
    name: 'Malagasy',
    local_name: 'Malagasy fiteny',
  },
  {
    code: 'ms',
    name: 'Malay',
    local_name: 'بهاس ملايو‎',
  },
  {
    code: 'ml',
    name: 'Malayalam',
    local_name: 'മലയാളം',
  },
  {
    code: 'mt',
    name: 'Maltese',
    local_name: 'Malti',
  },
  {
    code: 'mi',
    name: 'Māori',
    local_name: 'Māori',
  },
  {
    code: 'mr',
    name: 'Marathi (Marāṭhī)',
    local_name: 'मराठी',
  },
  {
    code: 'mh',
    name: 'Marshallese',
    local_name: 'Kajin M̧ajeļ',
  },
  {
    code: 'mn',
    name: 'Mongolian',
    local_name: 'Монгол',
  },
  {
    code: 'na',
    name: 'Nauru',
    local_name: 'Ekakairũ Naoero',
  },
  {
    code: 'nv',
    name: 'Navajo',
    local_name: 'Diné bizaad',
  },
  {
    code: 'nb',
    name: 'Norwegian Bokmål',
    local_name: 'Norsk bokmål',
  },
  {
    code: 'nd',
    name: 'North Ndebele',
    local_name: 'isiNdebele',
  },
  {
    code: 'ne',
    name: 'Nepali',
    local_name: 'नेपाली',
  },
  {
    code: 'ng',
    name: 'Ndonga',
    local_name: 'Owambo',
  },
  {
    code: 'nn',
    name: 'Norwegian Nynorsk',
    local_name: 'Norsk nynorsk',
  },
  {
    code: 'no',
    name: 'Norwegian',
    local_name: 'Norsk',
  },
  {
    code: 'ii',
    name: 'Nuosu',
    local_name: 'ꆈꌠ꒿ Nuosuhxop',
  },
  {
    code: 'nr',
    name: 'South Ndebele',
    local_name: 'isiNdebele',
  },
  {
    code: 'oc',
    name: 'Occitan',
    local_name: 'Occitan',
  },
  {
    code: 'oj',
    name: 'Ojibwe, Ojibwa',
    local_name: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
  },
  {
    code: 'om',
    name: 'Oromo',
    local_name: 'Afaan Oromoo',
  },
  {
    code: 'or',
    name: 'Oriya',
    local_name: 'ଓଡ଼ିଆ',
  },
  {
    code: 'os',
    name: 'Ossetian',
    local_name: 'Ирон æвзаг',
  },
  {
    code: 'pa',
    name: 'Panjabi',
    local_name: 'ਪੰਜਾਬੀ, پنجابی‎',
  },
  {
    code: 'pi',
    name: 'Pāli',
    local_name: 'पाऴि',
  },
  {
    code: 'fa',
    name: 'Persian',
    local_name: 'فارسی',
  },
  {
    code: 'pl',
    name: 'Polish',
    local_name: 'Polski',
  },
  {
    code: 'ps',
    name: 'Pashto, Pushto',
    local_name: 'پښتو',
  },
  {
    code: 'pt',
    name: 'Portuguese',
    local_name: 'Português',
  },
  {
    code: 'qu',
    name: 'Quechua',
    local_name: 'Runa Simi',
  },
  {
    code: 'rm',
    name: 'Romansh',
    local_name: 'Rumantsch grischun',
  },
  {
    code: 'rn',
    name: 'Kirundi',
    local_name: 'kiRundi',
  },
  {
    code: 'ro',
    name: 'Romanian',
    local_name: 'Română',
  },
  {
    code: 'ru',
    name: 'Russian',
    local_name: 'Русский язык',
  },
  {
    code: 'sa',
    name: 'Sanskrit (Saṁskṛta)',
    local_name: 'संस्कृतम्',
  },
  {
    code: 'sc',
    name: 'Sardinian',
    local_name: 'Sardu',
  },
  {
    code: 'sd',
    name: 'Sindhi',
    local_name: 'सिन्धी, سنڌي، سندھی‎',
  },
  {
    code: 'se',
    name: 'Northern Sami',
    local_name: 'Davvisámegiella',
  },
  {
    code: 'sm',
    name: 'Samoan',
    local_name: 'Gagana faa Samoa',
  },
  {
    code: 'sg',
    name: 'Sango',
    local_name: 'Yângâ tî sängö',
  },
  {
    code: 'sr',
    name: 'Serbian',
    local_name: 'Српски језик',
  },
  {
    code: 'gd',
    name: 'Scottish Gaelic; Gaelic',
    local_name: 'Gàidhlig',
  },
  {
    code: 'sn',
    name: 'Shona',
    local_name: 'ChiShona',
  },
  {
    code: 'si',
    name: 'Sinhala, Sinhalese',
    local_name: 'සිංහල',
  },
  {
    code: 'sk',
    name: 'Slovak',
    local_name: 'Slovenčina',
  },
  {
    code: 'sl',
    name: 'Slovene',
    local_name: 'Slovenščina',
  },
  {
    code: 'so',
    name: 'Somali',
    local_name: 'Soomaaliga',
  },
  {
    code: 'st',
    name: 'Southern Sotho',
    local_name: 'Sesotho',
  },
  {
    code: 'es',
    name: 'Spanish',
    local_name: 'Español',
  },
  {
    code: 'su',
    name: 'Sundanese',
    local_name: 'Basa Sunda',
  },
  {
    code: 'sw',
    name: 'Swahili',
    local_name: 'Kiswahili',
  },
  {
    code: 'ss',
    name: 'Swati',
    local_name: 'SiSwati',
  },
  {
    code: 'sv',
    name: 'Swedish',
    local_name: 'Svenska',
  },
  {
    code: 'ta',
    name: 'Tamil',
    local_name: 'தமிழ்',
  },
  {
    code: 'te',
    name: 'Telugu',
    local_name: 'తెలుగు',
  },
  {
    code: 'tg',
    name: 'Tajik',
    local_name: 'Тоҷикӣ',
  },
  {
    code: 'th',
    name: 'Thai',
    local_name: 'ไทย',
  },
  {
    code: 'ti',
    name: 'Tigrinya',
    local_name: 'ትግርኛ',
  },
  {
    code: 'bo',
    name: 'Tibetan',
    local_name: 'བོད་ཡིག',
  },
  {
    code: 'tk',
    name: 'Turkmen',
    local_name: 'Türkmen',
  },
  {
    code: 'tl',
    name: 'Tagalog',
    local_name: 'Wikang Tagalog',
  },
  {
    code: 'tn',
    name: 'Tswana',
    local_name: 'Setswana',
  },
  {
    code: 'to',
    name: 'Tonga (Tonga Islands)',
    local_name: 'Faka Tonga',
  },
  {
    code: 'tr',
    name: 'Turkish',
    local_name: 'Türkçe',
  },
  {
    code: 'ts',
    name: 'Tsonga',
    local_name: 'Xitsonga',
  },
  {
    code: 'tt',
    name: 'Tatar',
    local_name: 'Tатарча',
  },
  {
    code: 'tw',
    name: 'Twi',
    local_name: 'Twi',
  },
  {
    code: 'ty',
    name: 'Tahitian',
    local_name: 'Reo Tahiti',
  },
  {
    code: 'ug',
    name: 'Uighur',
    local_name: 'Uyƣurqə, ئۇيغۇرچە‎',
  },
  {
    code: 'uk',
    name: 'Ukrainian',
    local_name: 'Українська',
  },
  {
    code: 'ur',
    name: 'Urdu',
    local_name: 'اردو',
  },
  {
    code: 'uz',
    name: 'Uzbek',
    local_name: 'Ўзбек, أۇزبېك‎',
  },
  {
    code: 've',
    name: 'Venda',
    local_name: 'Tshivenḓa',
  },
  {
    code: 'vi',
    name: 'Vietnamese',
    local_name: 'Tiếng Việt',
  },
  {
    code: 'vo',
    name: 'Volapük',
    local_name: 'Volapük',
  },
  {
    code: 'wa',
    name: 'Walloon',
    local_name: 'Walon',
  },
  {
    code: 'cy',
    name: 'Welsh',
    local_name: 'Cymraeg',
  },
  {
    code: 'wo',
    name: 'Wolof',
    local_name: 'Wollof',
  },
  {
    code: 'fy',
    name: 'Western Frisian',
    local_name: 'Frysk',
  },
  {
    code: 'xh',
    name: 'Xhosa',
    local_name: 'isiXhosa',
  },
  {
    code: 'yi',
    name: 'Yiddish',
    local_name: 'ייִדיש',
  },
  {
    code: 'yo',
    name: 'Yoruba',
    local_name: 'Yorùbá',
  },
  {
    code: 'za',
    name: 'Zhuang',
    local_name: 'Saɯ cueŋƅ',
  },
];
